/**
 * Created by chengpanwang on 2017/3/23.
 */
import axios from 'axios'
import qs from 'qs'
const Http = {
  install (Vue, options) {
    // ajax 实例
    var http = axios.create({
      baseURL: Vue.prototype.$appConfig.baseUrl,
      timeout: 600000,
      // withCredentials: true,
      responseType: 'json',
      transformRequest: [
        function (data, headers) {
          // FormData 必须原样提交，禁止 qs.stringify（否则 multipart 被弄坏，上传 503）
          if (typeof FormData !== 'undefined' && data instanceof FormData) {
            if (headers) {
              if (typeof headers.delete === 'function') {
                headers.delete('Content-Type')
              } else {
                delete headers['Content-Type']
                delete headers['content-type']
              }
            }
            return data
          }
          // 将 sorts 数组转为扁平 sortProperty/sortDirection，避免嵌套对象绑定错误
          if (data && typeof data === 'object') {
            if (data.sorts && Array.isArray(data.sorts) && data.sorts.length > 0) {
              data.sortProperty = data.sorts[0].property
              data.sortDirection = data.sorts[0].direction
            }
            delete data.sorts
          }

          return qs.stringify(data,
            {
              arrayFormat: 'repeat',
              skipNulls: true,
              allowDots: true
            })
        }],
      transformResponse: [
        function (data) {
          return data
        }],
      paramsSerializer: function (params) {
        let paramKeyValue = qs.stringify(params,
          {arrayFormat: 'repeat', skipNulls: true, allowDots: true})
        return paramKeyValue
      },
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Headers': '*'
      }
    })

    var logger = Vue.prototype.$logger
    var store = Vue.prototype.$store

    // 全局处理http请求
    http.interceptors.request.use(function (config) {
      if (config) {
        if (store.get('token')) {
          config.headers.token = store.get('token')
        }
        if (store.get('account') && store.get('password')) {
          config.headers.account = store.get('account')
          config.headers.password = store.get('password')
        }
      }
      return config
    }, function (error) {
      logger.debug(error)
      return Promise.reject(error)
    })

    // 全局处理http 请求结果，错误，token失效
    var router = options.router
    var message = Vue.prototype.$Message
    var isMessageShow = false
    http.interceptors.response.use(function (response) {
      let headers = response.headers
      if (headers['content-type'].indexOf('application/octet-stream') >= 0) {
        return response
      }
      if (headers['content-type'].indexOf('text/event-stream') >= 0) {
        return response
      }
      // 处理 Excel 文件导出
      if (headers['content-type'].indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') >= 0) {
        return response
      }
      if (headers['content-type'].indexOf('application/vnd.ms-excel') >= 0) {
        return response
      }
      if (typeof response.data === 'string') {
        // 尝试解析字符串为 JSON
        try {
          response.data = JSON.parse(response.data)
        } catch (e) {
          console.warn('Response data is not JSON:', e.message)
          // 响应数据是非JSON字符串，保留原样
        }
      }
      var data = response.data
      if (data.status === 'ok') {
        return data
      } else if (data.status === '601') {
        if (!isMessageShow) {
          isMessageShow = true
          message.error({
            content: data.msg,
            onClose () {
              isMessageShow = false
            }
          })
        }
        var backUrl = ''
        if (router.currentRoute) {
          backUrl = router.currentRoute.path
        }
        router.push({path: '/login', query: {backUrl: backUrl}})
      } else {
        if (!response.config.silent && !isMessageShow) {
          isMessageShow = true
          message.error({
            content: data.msg,
            onClose () {
              isMessageShow = false
            }
          })
        }
        return data
      }
    }, function (error) {
      logger.info('ajax错误过滤器', error)
      message.error('系统繁忙')
      return Promise.reject(error)
    })
    Vue.prototype.$http = http
  }
}

export default Http



// WEBPACK FOOTER //
// ./src/plugins/Http.js